module.exports = __webpack_public_path__ + "img/example-right.be03d38.png";